module.exports = __webpack_public_path__ + "assets/74bb2ebbc100759ef4f922d1e9a200b7.svg";